export default "__VITE_ASSET__C3R_3V0V__"